<template>
    <div>
        <div class="basket-summary__product-row" v-for="line in lines" :key="line.id">
            <a :href="url(line.variant)" class="basket-product-img">
                <img :src="thumb(line.variant)" class="basket-summary__product-image" alt="#">
            </a>
            <div class="basket-summary__product-details">
                <div class="basket-summary__product-title">
                    {{ line.variant.product.name }}
                </div>
                <div class="basket-summary__product-qty">
                    Qty: {{ line.quantity }}
                </div>
                <div class="basket-summary__product-cost">
                    <product-price :price="line.line_total" :tax="line.tax"></product-price>
                </div>
            </div>
        </div>
        <section class="summary-show-all" v-if="hiddenCount > 0">
            <template v-if="!showAll">
                Plus  {{ hiddenCount }} more lines <a href="#" @click.prevent="showAll = true" v-if="!showAll">Show all</a>
            </template>
            <template v-else>
                <a href="#" @click.prevent="showAll = false">Show less</a>
            </template>
        </section>

        <!-- <div class="basket-summary__product-row">
                    @if($line->variant->product->thumbnail)
                      <img class="basket-summary__product-image" src="{{ $line->variant->product->thumbnail->url }}" alt="{{ $line->variant->product->thumbnail->title }}">
                    @else
                      <img class="basket-summary__product-image" src="/img/orbital/products/placeholder.png" alt="{{ $line->variant->product->name }}" width="210">
                    @endif
                    <div class="basket-summary__product-details">
                        <div class="basket-summary__product-title">
                            {{ $line->variant->product->name }}
                        </div>
                        <div class="basket-summary__product-qty">
                            Qty: {{ $line->quantity }}
                        </div>
                        <div class="basket-summary__product-cost">
                          <product-price :price="{{ $line->line_total }}" :tax="{{ $line->tax }}"></product-price>
                        </div>
                    </div>
                </div> -->
    </div>
</template>

<script>
    import Basket from '../../Services/Basket.js';
    import ProductPrice from '../Product/ProductPrice.vue';

    export default {
        components: {
            ProductPrice
        },
        data() {
            return {
                service: Basket,
                showAll: false,
                limit: 3
            }
        },
        mounted() {
            this.service.getBasket();
        },
        methods: {
            url(variant) {
                let url;

                if (variant.product) {
                    url = variant.product.routes[0].slug;
                } else {
                    url = variant.routes[0].slug;
                }
                return route('get.product', url);
            },
            thumb(variant) {
                var primary = _.find(variant.product.assets, asset => {
                    return asset.primary;
                });
                if (!primary) {
                    return '/img/orbital/products/placeholder.jpg';
                }
                return primary.transforms[0].url;

            },
        },
        computed: {
            hiddenCount() {
                return this.service.basket.lines.length ? this.service.basket.lines.length - this.limit : 0;
            },
            lines() {
                if (!this.showAll) {
                    return _.take(this.service.basket.lines, this.limit);
                }
                return this.service.basket.lines;
            },
            discounts() {
                return this.service.basket.discounts;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .summary-show-all {
        margin-top:1em;
        background-color:#f5f5f5;
        color:#8795A1;
        padding:.5em 0;
        text-align:center;
        font-size:.875em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket/BasketSummary.vue